<div class="body" [formGroup]="formGroup">

    <mat-toolbar class="ams-toolbar">
        <button mat-icon-button>
            <mat-icon>delete_forever</mat-icon>
        </button>
        <span>Kunden löschen - Optionen</span>
        <span class="spacer"></span>
        <span matSuffix>

            <button mat-icon-button color="warn" (click)="close()">
                <mat-icon>close</mat-icon>
            </button>

        </span>
    </mat-toolbar>

    <div class="content" [formGroup]="formGroup">

        <div class="hint">
            Wählen Sie, wie mit verknüpften Datensätzen umgegangen werden soll. Achtung! Gelöschte Daten sind dauerhaft verloren!
        </div>

        <div class="toggle-wrapper">

            <mat-slide-toggle formControlName="deleteIssues">
                Vorgänge / Tickets / RFCs ebenfalls löschen
            </mat-slide-toggle>

            <mat-slide-toggle formControlName="deleteContracts">
                Verträge ebenfalls löschen
            </mat-slide-toggle>

        </div>

    </div>

    <div class="footer">

        <button (click)="close()" mat-raised-button>
            Abbrechen
        </button>

        <button [disabled]="formGroup.invalid" (click)="confirm()" mat-raised-button color="warn">
            Endgültig löschen
        </button>

    </div>

</div>
